// O QUE E GRATIS E O QUE E PAGO -- decisao de negocio, num lugar so.
//
// Espelha o modelo do 38 Brasil: o campeonato brasileiro e gratis e completo, e
// o resto do mundo abre com um Pix unico, sem mensalidade. Aqui: NBB gratis,
// NBA no premium.
//
// Se voce quiser inverter (NBA gratis, NBB premium) ou liberar tudo, mude
// FREE_LEAGUES abaixo -- e a unica linha que decide isso no jogo inteiro.

export const FREE_LEAGUES = ['nbb'];

/**
 * A configuracao PUBLICADA pelo painel CEO manda sobre estes valores.
 * Ela chega do servidor no boot; enquanto nao chega (ou se o servidor estiver
 * fora), valem os valores daqui -- o jogo nunca fica esperando a rede para
 * abrir.
 */
let publicado = null;

export function applyPublishedConfig(cfg) {
  if (!cfg) return;
  publicado = {
    preco: Number(cfg.preco) > 0 ? Number(cfg.preco) : null,
    ligasGratis: Array.isArray(cfg.ligasGratis) && cfg.ligasGratis.length ? cfg.ligasGratis : null,
  };
  if (publicado.preco) {
    PREMIUM.price = publicado.preco;
    PREMIUM.priceLabel = `R$ ${publicado.preco.toFixed(2).replace('.', ',')}`;
  }
}

export const PREMIUM = {
  price: 19.9,
  priceLabel: 'R$ 19,90',
  kind: 'vitalicio',
  name: '82 Mundo',
  pitch: 'Quando quiser sair do Brasil, a NBA abre.',
  features: [
    'NBA completa: 30 times',
    '82 rodadas e playoffs',
    'Draft com loteria',
    'Teto salarial e imposto de luxo',
    'Save na nuvem',
    'Historico de temporadas',
  ],
};

export const isLeagueFree = (leagueId) =>
  (publicado?.ligasGratis || FREE_LEAGUES).includes(leagueId);
